var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-menu',{staticClass:"hori-center",attrs:{"mode":"horizontal","background-color":"#2A8AE0","text-color":"#FFFFFF","router":true,"default-active":_vm.activePath}},_vm._l((_vm.navList),function(item){return _c('el-menu-item',{key:item.index,staticClass:"item",attrs:{"index":item.index}},[_vm._v(_vm._s(item.label))])}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }